<template>
  <div type="input" class="datalist">
    <input
      class="datalist-input"
      list="input-list"
      autocomplete="new-password"
      v-model="inputVal"
      :placeholder="placeholder"
      @focus="onFocus()"
      @blur="onBlur($event.target.value)"
      :disabled="disable"
      :type="type"
    />
    <div class="datalist-options" v-show="dataListShow && options.length > 0">
      <p
        class="datalist-options-option"
        v-for="item in options"
        :key="item.value"
        :value="item.value"
        @click="selectVal(item)"
        @touch="selectVal(item)"
      >
        {{ item.label }}
      </p>
    </div>
  </div>
</template>

<script>
import themeMixins from '@mixins/officialTopup/themeMixins';

export default {
  mixins: [themeMixins],
  props: ['value', 'placeholder', 'disable', 'pointClass', 'options', 'type'],
  data() {
    return {
      dataListShow: false
    };
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('update:value', val);
        this.$emit('change', val);
      }
    }
  },
  methods: {
    onFocus() {
      this.dataListShow = true;
      this.$emit('focus');
    },
    onBlur(val) {
      // blur 和 click 事件冲突，延迟隐藏
      setTimeout(() => {
        this.dataListShow = false;
        this.$emit('blur', val);
      }, 200);
    },
    selectVal(option) {
      this.inputVal = option.value;
      this.dataListShow = false;
      this.$emit('select', option);
    }
  }
};
</script>

<style scoped lang="scss">
.datalist {
  position: relative;
  height: 100%;

  &-input {
    width: 100%;
    height: 100%;
    border: none;
    background: none;
    outline: none;
  }

  &-options {
    position: absolute;
    top: 110%;
    left: 0;
    width: 100%;
    max-height: 300px;
    background: #ffffff;
    border: 1px solid #ccc;
    z-index: 99;
    overflow-y: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &-option {
      line-height: 40px;
      padding: 10px 20px;
      cursor: pointer;
    }
    &-option + &-option {
      border-top: 1px solid #ccc;
    }
  }
}

/* 隐藏滚动条 */
.datalist-options::-webkit-scrollbar {
  display: none;
}

input {
  border: none;
  background: none;
  outline: none;
}
</style>
